module.exports = __webpack_public_path__ + "img/box3-2.ceb85bc5.png";